import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    job_id : 0,
    pitcher_id : 0,
    parent_catcher_id : 0,
    catcher_id : 0,
    browser : '',
    device:'',
    os:'',
    os_version:'',
    os_name:'',
    full_version:'',
    browser_name:''
};

const generalSlice = createSlice({
    name:'general',
    initialState,
    reducers : {
        setJobId : (state, {payload}) => {
            state.job_id = payload;
        },
        setPitcherId : (state, {payload}) => {
            state.pitcher_id = payload;
        },
        setCatcherId : (state, {payload}) => {
            state.catcher_id = payload;
        },
        setParentCatcherId : (state, {payload}) => {
            state.parent_catcher_id = payload;
        },
        setOsVersion : (state, {payload}) => {
            state.os_version = payload;
        },
        setOsName : (state, {payload}) => {
            state.os_name = payload;
        },
        setBrowserName : (state, {payload}) => {
            state.browser_name = payload;
        },
        setFullVersion : (state, {payload}) => {
            state.full_version = payload;
        },
    }
})

export const {
    setJobId, setPitcherId, setCatcherId, setParentCatcherId, setOsVersion, setOsName, setBrowserName, setFullVersion
} = generalSlice.actions;

export const getDetails = (state) => state.general;

export default generalSlice.reducer;